import React from 'react'
import { startOfWeek, endOfWeek, eachDayOfInterval, format, addDays, subDays, startOfToday } from 'date-fns'
import TeacherCalendarWeekViewHeader from './TeacherCalendarWeekViewHeader'
import WeekViewGrid from './WeekViewGrid'
import WeekViewHorizontal from './WeekViewHorizontal'
import WeekViewEventChip from './WeekViewEventChip'
import LargeWeekView from './LargeWeekView'
import SmallWeekView from '../SmallWeekView'
import { createEventObjectForTeacherWeekView, createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime } from '../../../../Calendar/calendarFunctions'

const TeacherCalendarWeekView = ({selectedDay, setSelectedDay, setTeacherCalendarView, openEvent, setOpenEvent, allEvents, createANewCalendarEvent, teacherCalendarView}) => {
  const [displayedWeek, setDisplayedWeek] = React.useState(eachDayOfInterval({start: startOfWeek(new Date(selectedDay.date)), end: endOfWeek(new Date(selectedDay.date))}))  
  const [weekViewEventObject, setWeekViewEventObject] = React.useState([])
  const [calendarDaysWithEvents, setCalendarDaysWithEvents] = React.useState({})
  const container = React.useRef(null)
  const containerNav = React.useRef(null)
  const containerOffset = React.useRef(null)

  React.useEffect(() => {
    // Set the container scroll position based on the current time.
    const currentMinute = new Date().getHours() * 60
    container.current.scrollTop = ((container.current.scrollHeight - containerNav.current.offsetHeight - containerOffset.current.offsetHeight) * currentMinute) / 1440
      console.log(selectedDay)
  }, [])

  React.useEffect(() => {
    setDisplayedWeek(eachDayOfInterval({start: startOfWeek(new Date(selectedDay.date)), end: endOfWeek(new Date(selectedDay.date))}))
  }, [selectedDay.date])

  React.useEffect(() => {
    createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime(displayedWeek, allEvents, setCalendarDaysWithEvents)
  }, [displayedWeek, allEvents])

  React.useEffect(() => {
    createEventObjectForTeacherWeekView(displayedWeek, calendarDaysWithEvents, setWeekViewEventObject)
  }, [calendarDaysWithEvents])

  const changeWeek = (day, direction) => {
    let formattedDay = format(day, 'yyyy-MM-dd')
    if(direction === 'forward') {
      formattedDay = format(addDays(selectedDay.date, 7), 'yyyy-MM-dd')
    } else if (direction === 'back') {
      formattedDay = format(subDays(selectedDay.date, 7), 'yyyy-MM-dd')
    } else if (direction === 'jump') {
      formattedDay = format(startOfToday(), 'yyyy-MM-dd')
    }
    const [year, month, date] = formattedDay.split('-').map(Number);
    const newDate = new Date(year, month - 1, date);
    setSelectedDay({date: newDate, events: calendarDaysWithEvents[formattedDay] && calendarDaysWithEvents[formattedDay].events, availabilities: calendarDaysWithEvents[formattedDay] && calendarDaysWithEvents[formattedDay].availabilities})
    setDisplayedWeek(eachDayOfInterval({start: startOfWeek(day), end: endOfWeek(day)}))
  }

  return (
        <div className="flex h-full w-11/12 m-auto flex-col">
          <TeacherCalendarWeekViewHeader setTeacherCalendarView={setTeacherCalendarView} changeWeek={changeWeek} selectedDay={selectedDay} displayedWeek={displayedWeek} createANewCalendarEvent={createANewCalendarEvent} teacherCalendarView={teacherCalendarView} />
          <div ref={container} className="isolate flex flex-auto flex-col overflow-auto overflow-x-hidden bg-white">
            <div style={{ width: '165%' }} className="flex max-w-full flex-none flex-col sm:max-w-none md:max-w-full">
              <div ref={containerNav} className="sticky top-0 z-100 flex-none bg-white  shadow ring-1 ring-black ring-opacity-5 sm:pr-8">
                <SmallWeekView displayedWeek={displayedWeek} selectedDay={selectedDay} setSelectedDay={setSelectedDay} weekViewEventObject={weekViewEventObject} calendarDaysWithEvents={calendarDaysWithEvents} />     
                <LargeWeekView displayedWeek={displayedWeek} selectedDay={selectedDay} weekViewEventObject={weekViewEventObject} />
              </div>
              <div className="flex flex-auto">
                <div className="sticky left-0 -z-10 w-14 flex-none bg-white ring-1 ring-gray-100" />
                <div className="grid flex-auto grid-cols-1 grid-rows-1">
                  <WeekViewGrid containerOffset={containerOffset} />
                  <WeekViewHorizontal />
                  <ol className="col-start-1 col-end-2 row-start-1 grid grid-cols-1 mt-0 mb-0 sm:grid-cols-7 sm:pr-8" style={{ gridTemplateRows: '1.75rem repeat(288, minmax(0, 1fr)) auto' }}>
                    {weekViewEventObject.map((event) => <WeekViewEventChip key={event.id} event={event} openEvent={openEvent} setOpenEvent={setOpenEvent} selectedDay={selectedDay} />)}
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
}
export default TeacherCalendarWeekView